import headerImgEn from "assets/images/v109/header-en.webp"
import infoImgEn from "assets/images/v109/info-en.webp"
import headerImgFr from "assets/images/v109/header-fr.webp"
import infoImgFr from "assets/images/v109/info-fr.webp"
import headerImgEs from "assets/images/v109/header-es.webp"
import infoImgEs from "assets/images/v109/info-es.webp"
import headerImgDe from "assets/images/v109/header-de.webp"
import infoImgDe from "assets/images/v109/info-de.webp"
import headerImgIt from "assets/images/v109/header-it.webp"
import infoImgIt from "assets/images/v109/info-it.webp"

export const v109ConfigImages: Record<string, Record<string, string>> = {
  header: {
    en: headerImgEn,
    fr: headerImgFr,
    es: headerImgEs,
    de: headerImgDe,
    it: headerImgIt,
  },
  info: {
    en: infoImgEn,
    fr: infoImgFr,
    es: infoImgEs,
    de: infoImgDe,
    it: infoImgIt,
  },
}
